import { UIColor, UITextView, UIView } from "uicore-ts"
import { RHColor } from "./RHColor"


/**
 * RHBadgeView om lihtne märgi-komponent, miä om inspireerit nupuvaatõst.
 * See on mõeldud kasutamiseks CellView 'custom' variandis olekute kuvamiseks.
 */
export class RHBadgeView extends UIView {

    // Horizontal breathing room around the label inside the pill — shared by
    // layoutSubviews and intrinsicContentWidth so the two can never drift apart.
    static readonly labelHorizontalBreathingRoom = 20 + 10

    // Kasutame UITextView-d teksti näitamiseks, sarnaselt nupule [cite: 1]
    readonly label = new UITextView().addedAsSubviewToView(this).configuredWithObject({
        style: {
            whiteSpace: "nowrap",
            borderRadius: "100px", // Teeb märgi ümaraks (pill)
            padding: "2px 10px",
            fontSize: "12px",
            fontWeight: "600",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center"
        }
    })
    
    constructor(elementID?: string) {
        super(elementID)
        
        // Vaikimisi stiil, mis meenutab neutraalset märki
        this.label.style.backgroundColor = RHColor.lightGreyColor.stringValue
        this.label.style.color = RHColor.greyColor.stringValue
        this.label.textAlignment = UITextView.textAlignment.center
    }
    
    /**
     * Seab märgi teksti. [cite: 1]
     */
    set text(text: string) {
        if (this.label.text === text) {
            return
        }
        this.label.text = text
        this.setNeedsLayout()
    }
    
    get text(): string {
        return this.label.text
    }
    
    /**
     * Võimaldab vahetada märgi värvust vastavalt staatusele.
     */
    setVariant(backgroundColor: UIColor, textColor = RHColor.textWhite) {
        this.label.configureWithObject({
            backgroundColor: backgroundColor,
            textColor: textColor
        })
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        const padding = this.core.paddingLength
        
        // Paigutame märgi keskele, sarnaselt RHTableActionButtonView-le [cite: 1]
        // rectangleWithWidth ja Height (0.5) tsentreerivad vaate [cite: 1]
        this.label.frame = this.contentBounds
            // .rectangleByAddingWidth(20 + 10, 0.5)
            .rectangleWithWidth(this.label, 0.5)
            .rectangleByAddingWidth(RHBadgeView.labelHorizontalBreathingRoom, 0.5)
            .rectangleWithHeight(24, 0.5)
    }
    
    override intrinsicContentHeight(constrainingWidth = 0) {
        return 32 // Standardne kõrgus, mis sobib CellView-ga
    }

    override intrinsicContentWidth(constrainingHeight = 0): number {
        // Pill width = label width + the same breathing room layoutSubviews adds.
        return this.label.intrinsicContentWidth(constrainingHeight) +
            RHBadgeView.labelHorizontalBreathingRoom
    }
}
